module.exports = __webpack_public_path__ + "static/media/contratadas.91f653dd.png";